// Boiler Plate Imports
import React, { useEffect, useMemo, useState } from "react";
import colors from "../../theme/colors";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import {
  remove as removeNotification,
  add as addNotification,
} from "../../redux-store/notificationsSlice";
import { update as setBreadCrumbs } from "../../redux-store/breadCrumbsSlice";
import API from "../../api";

// Conatiner Component Imports
import { Button, Card } from "@mui/material";
import BreadCrumbs from "../../components/Navigation/breadcrumbs";
import ModalComponent from "../../components/Modal";
import TableHeader from "../../components/Page/tableHeader";

// Page Component Imports
import AdminOrganizationForm from "../../components/Forms/adminOrganizationForm";
import { FormatPhoneNumber } from "../../components/PhoneNumberInput";
import MetricBoxes from "../../components/Page/metricBoxes";
import {
  TableComponent,
  ItemLink,
  StatusTag,
} from "../../components/Table/dataGridPro";
import MetricBoxesComponent from "../../components/Page/metricBoxes";
import { useNavigate } from "react-router-dom";

const ActiveAlarmsTagNone = styled.div`
  background: ${colors.grayLight};
  color: ${colors.grayDark};
  border: 1px solid ${colors.gray};
  border-radius: 15px;
  text-align: center;
  padding: 2px;
  width: 60px;
`;

const ActiveAlarmsTagSome = styled.div`
  background: ${colors.redLightError};
  color: ${colors.redError};
  border: 1px solid ${colors.redError};
  border-radius: 15px;
  text-align: center;
  padding: 2px;
  width: 60px;
  font-weight: bold;
`;

const PaddingWrapper = styled.div`
  padding: 0 15px 10px;
  @media (max-width: 1080px) {
    padding: 0 0px 10px;
  }
`;

const AlertHeader = styled.h1`
  padding: 20px;
`;

const Table = React.memo(TableComponent);

const MyNetworksContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [metrics, setMetrics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reloadData, setReloadData] = useState(false);

  const [networks, setNetworks] = useState([]);

  const tableColumns = useMemo(
    () => [
      {
        headerName: "Organization Name",
        field: "name",
        valueGetter: (value, row) => {
          return row.name;
        },
        renderCell: ({ row }) => {
          return (
            <ItemLink to={`/${row.id}/organization/`}>{row.name}</ItemLink>
          );
        },
      },
      {
        headerName: "Access Level",
        field: "accessLevel",
        type: "string",
        display: "flex",
        valueGetter: (value, row) => {
          return row.accessLevel;
        },
        renderCell: ({ row }) => {
          if (row.accessLevel === "READ-ONLY") {
            return <StatusTag>Read Only</StatusTag>;
          } else if (row.accessLevel === "FULL-ACCESS") {
            return <StatusTag className={"resolved"}>Full Access</StatusTag>;
          }
        },
      },
      {
        headerName: "Active Alarm",
        field: "activeAlarmsCount",
        type: "number",
        display: "flex",
        valueGetter: (value, row) => {
          return row.activeAlarmsCount;
        },
        renderCell: ({ row }) => {
          if (row.activeAlarmsCount === 0) {
            return <StatusTag>none</StatusTag>;
          } else {
            return (
              <StatusTag className={"alarm"}>{row.activeAlarmsCount}</StatusTag>
            );
          }
        },
      },
      {
        headerName: "Total Locations",
        field: "locationsCount",
        type: "number",
      },
      {
        headerName: "Total Tanks",
        field: "tanksCount",
        type: "number",
      },
      {
        headerName: "Total Users",
        field: "usersCount",
        type: "number",
      },
      {
        headerName: "Date Created",
        field: "created",
        type: "dateTime",
        valueGetter: (value, row) => {
          return new Date(value);
        },
      },
    ],
    []
  );

  useEffect(() => {
    dataLayer.GetUserNetworks();
    setMetrics([
      {
        title: "ACTIVE ALARMS",
        value: "-",
      },
      {
        title: "ORGANIZATIONS",
        value: "-",
      },
      {
        title: "LOCATIONS",
        value: "-",
      },
      {
        title: "TANKS",
        value: "-",
      },
    ]);
    dispatch(
      setBreadCrumbs([
        {
          title: "My Networks",
          link: "/networks",
        },
      ])
    );
  }, []);

  const dataLayer = {
    GetUserNetworks: async () => {
      setLoading(true);
      const { networks, metrics: _metrics } =
        await API.Network.NetworkGetUserNetworks();

      setNetworks(networks);
      setMetrics([
        {
          title: "ACTIVE ALARMS",
          value: _metrics?.activeAlarmsCount || 0,
        },
        {
          title: "ORGANIZATIONS",
          value: _metrics?.organizationsCount || 0,
        },
        {
          title: "LOCATIONS",
          value: _metrics?.locationsCount || 0,
        },
        {
          title: "TANKS",
          value: _metrics?.tanksCount || 0,
        },
      ]);
      setLoading(false);
    },
  };

  return (
    <>
      
      <MetricBoxesComponent title={""} metrics={metrics} />

      {networks.map(({ network, metrics }) => {
        return (
          <PaddingWrapper key={`${network.id}`}>
            <Card>
              <TableHeader>
                <div>
                  <h2>{network.name}</h2>
                </div>
              </TableHeader>
              <Table
                columns={tableColumns}
                label={""}
                isAdminView={true}
                reloadData={reloadData}
                loadingOverride={loading}
                placeholder="There are no Organizations in Network"
                getRowsFunction={async () => {
                  return network.organizations;
                }}
                initialState={{
                  pinnedColumns: { left: ["name"] },
                  sorting: {
                    sortModel: [{ field: "name", sort: "asc" }],
                  },
                }}
              />
            </Card>
          </PaddingWrapper>
        );
      })}
    </>
  );
};

export default MyNetworksContainer;
